export default __webpack_public_path__ + "static/media/facebook_event_cover.9ee79d76.png";